import React from "react";

const Eigth_Answer = () => {
  return (
    <>
      <div className="eigth_answer">
        <p>
          This platform is a great opportunity for the winners to showcase the
          achievement.An exclusive opportunity for all participants to promote
          and raise the profile of their brand along with the glamour of the
          premium awards ceremony that focuses on being the exemplary, which is
          integral to your brand's growth. The event will capture and showcase
          the value and quality of your brand and showcase it to a premium
          audience in an ultra-premium setting! As one of the most prominent
          awards in India , do not miss this opportunity to showcase to the
          world as to why your brand is the best!
        </p>
      </div>
    </>
  );
};

export default Eigth_Answer;
